import { UiFloatModal } from "../../common/modal"
import style from "./comtrade.css"
import i18next from "i18next";

const template = () => `
    <style>${style}</style>
    <div class="container-comtrade">
        <p>${i18next.t('trend_comtrade_title_upload_btn')}</p>
        <button class="btn" id="comptrade-upload">${i18next.t('trend_comtrade_upload_btn')}</button>
        <div id="comptrade-uploaded"></div>
        <p id="title-format-comtrade">${i18next.t('trend_comtrade_title_format_modal')}</p>
        <input id="comptrade-input-format" type="text" value="DD/MM/YYYY,HH:mm:ss" />
        <button class="btn" id="comptrade-btn-apply">${i18next.t('import')}</button>
    </div>
`

export class Comtrade{
    constructor(root, btn){
        this.root = root
        this.btn = btn
        this.files = null
        this.init()
    }

    init(){
        this.modal = new UiFloatModal(template())
        if(!this.root.parentHasPopup) this.modal.root.style.zIndex = 10000100
        this.btn.addEventListener('click', this.toggle.bind(this))
        this.applyBtn = this.modal.modalComponent.querySelector('#comptrade-btn-apply')
        this.uploadBtn = this.modal.modalComponent.querySelector('#comptrade-upload')
        this.inputFormat = this.modal.modalComponent.querySelector('#comptrade-input-format')
        this.uploadedDiv = this.modal.modalComponent.querySelector('#comptrade-uploaded')
        this.uploadBtn.addEventListener('click', this.uploadFiles.bind(this))
        this.applyBtn.addEventListener('click', this.validateFiles.bind(this))
        this.modal.modalComponent.calculateInitialPosition = () => {
            const { top, left } = this.root.getBoundingClientRect()
            // 10 - это дополнительный отступ, чтобы не прилипало к верху
            return [left, top + this.root.toolbar.offsetHeight + 10]
        }
        this.modal.modalComponent.label = i18next.t('trend_comtrade_title_modal')
    }

    uploadFiles(){
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.cfg,.dat,.cff';
        fileInput.multiple = true;
        fileInput.style.display = 'none';

        fileInput.addEventListener('change', async (event) => {
            this.files = Array.from(event.target.files);
            this.updateUploaded();
        });

        fileInput.click();
    }

    updateUploaded(){
        if(this.files && this.files.length){
            let result = ``
            this.files.forEach(file => {
                result += `<div>${file.name}</div>`
            })
            this.uploadedDiv.innerHTML = `
            <p>${i18next.t('trend_comtrade_uploaded')}:</p>
            ${result}
        `
        } else {
            this.uploadedDiv.innerHTML = ``;
        }
    }

    validateFiles(){
        if (!this.files || this.files.length === 0) {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: i18next.t('trend_warning'),
                text: i18next.t('trend_comtrade_upload_error'),
            });
            return;
        }

        const fileGroups = {};
        this.files.forEach(file => {
            const baseName = file.name.replace(/\.(cfg|dat|cff)$/i, '');
            if (!fileGroups[baseName]) {
                fileGroups[baseName] = {};
            }
            const ext = file.name.split('.').pop().toLowerCase();
            fileGroups[baseName][ext] = file;
        });

        for (const baseName in fileGroups) {
            const group = fileGroups[baseName];

            if (!group.cfg || !group.dat) {
                $ns.add({
                    type: "warning",
                    time: new Date().toLocaleString(),
                    title: i18next.t('trend_warning'),
                    text: i18next.t('trend_comtrade_upload_error'),
                });
                continue;
            }
            this.root.parseComtrade(group, this.inputFormat.value)
        }
    }


    toggle(e) {
        this.modal.modalComponent.toggle()
        if (!this.modal.modalComponent.active) return
    }

    close(){
        this.modal.modalComponent.close();
    }

    destroy() {
        this.modal = null
    }
}
